import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, NonNullableFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '@coin/admin/core/data-access';
import { switchMapWithLoadingState } from '@coin/shared/core/util-helpers';
import { EmployeeLight } from '@coin/shared/core/util-models';
import { Subject, catchError, map } from 'rxjs';

@Component({
  selector: 'coin-a-search-employee-dialog',
  templateUrl: './search-employee-dialog.component.html',
  styleUrls: ['./search-employee-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SearchEmployeeDialogComponent {
  dialogRef = inject<MatDialogRef<SearchEmployeeDialogComponent>>(MatDialogRef);
  private userService = inject(UserService);
  private formBuilder = inject(NonNullableFormBuilder);

  public formGroup = this.formBuilder.group({
    employee: new FormControl<EmployeeLight>(null, Validators.required)
  });

  public employeeSearch$ = new Subject<string>();
  public employees$ = this.employeeSearch$.pipe(
    switchMapWithLoadingState(search =>
      this.userService.queryUsersByGID(search).pipe(
        map(result => result.content),
        catchError(() => [])
      )
    )
  );

  public onRemoveButtonClick(): void {
    this.formGroup.controls.employee.setValue(null);
  }

  public confirm(): void {
    this.dialogRef.close(this.formGroup.getRawValue().employee);
  }
}
